var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOpinionHeader = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 300 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M56 28H0V12H56V28ZM300 4H0V0H300V4Z",
  fill: "#DFDFDF"
})));
export default SvgOpinionHeader;